var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypeAppartement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_481_6486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 23.75H14.25V20.5833H17.4167V23.75ZM23.75 20.5833H20.5833V23.75H23.75V20.5833ZM17.4167 26.9167H14.25V30.0833H17.4167V26.9167ZM23.75 26.9167H20.5833V30.0833H23.75V26.9167ZM17.4167 7.91667H14.25V11.0833H17.4167V7.91667ZM23.75 7.91667H20.5833V11.0833H23.75V7.91667ZM17.4167 14.25H14.25V17.4167H17.4167V14.25ZM23.75 14.25H20.5833V17.4167H23.75V14.25ZM38 12.6667C38 10.0478 35.8688 7.91667 33.25 7.91667H30.0833V4.75C30.0833 2.13117 27.9522 0 25.3333 0H12.6667C10.0478 0 7.91667 2.13117 7.91667 4.75V14.25H4.75C2.13117 14.25 0 16.3812 0 19V38H38V12.6667ZM3.16667 19C3.16667 18.126 3.87758 17.4167 4.75 17.4167H11.0833V4.75C11.0833 3.876 11.7943 3.16667 12.6667 3.16667H25.3333C26.2058 3.16667 26.9167 3.876 26.9167 4.75V11.0833H33.25C34.1224 11.0833 34.8333 11.7927 34.8333 12.6667V34.8333H3.16667V19ZM31.6667 20.5833H28.5V23.75H31.6667V20.5833ZM31.6667 26.9167H28.5V30.0833H31.6667V26.9167ZM9.5 20.5833H6.33333V23.75H9.5V20.5833ZM9.5 26.9167H6.33333V30.0833H9.5V26.9167ZM31.6667 14.25H28.5V17.4167H31.6667V14.25Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_481_6486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeAppartement);
export default __webpack_public_path__ + "static/media/type_appartement.1adbb638abef5e19acd54b638801769a.svg";
export { ForwardRef as ReactComponent };